import React, { useEffect } from 'react';
import { Settings } from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { Route, Routes, Navigate } from 'react-router-dom';
import { startCatalogos } from '../../app/store/catalagos/thunks';
import { Customers } from './customers/Customers';
import { Dashboard } from './dashboards/Dashboard';
import { Employees } from './employees/Employees';
import { Finance } from './finance/Finance';
import { Global } from './globals/Global';

import { OrderClose } from './orderClose/OrderClose';

import { OrderTracking } from './orderTracking/OrderTracking';
import { Parts } from './parts/Parts';

import { Profile } from './profile/Profile';

import { Warehouse } from './warehouse/Warehouse';
import { NewOrder } from './orderNew/NewOrder';
import { Sales } from './sales/Sales';
import { Report } from './reportes/Report';
import { Invoicing } from './invoicing/Invoicing';
import { OrderDeparture } from './orderDeparture/OrderDeparture';
import { SalesOrder } from './salesbyOrder/SalesOrder';
import { Warranties } from './warranties/Warranties';
import { CashOut } from '../pages/finance/cashOut/CashOut';



export const AppRoutes = () => {
    const { usuario, nombre, puesto, avatar, status } = useSelector(state => state.usuario);

    // Carga inicial de catalogos
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(startCatalogos())
    }, [])


    // console.log(status);


    return (
        <>
            <Routes>
                {/* Rutas Principales */}
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/newOrder" element={<NewOrder />} />
                <Route path="/trackingOrder" element={<OrderTracking />} />
                <Route path="/trackingOrder/:folio" element={<OrderTracking />} />
                <Route path="/closeOrder" element={<OrderClose />} />
                <Route path="/closeOrder/:folio" element={<OrderClose />} />

                {/* Rutas de Modulos */}
                <Route path="/parts" element={<Parts />} />
                <Route path="/sales" element={<Sales />} />
                <Route path="/salesOrder" element={<SalesOrder />} />
                <Route path="/employees" element={<Employees />} />
                <Route path="/customers" element={<Customers />} />


                {/* Ruta de Garantias */}

                <Route path='/warranties' element={<Warranties />} />
                {/* <Route path=':view' element={<Warehouse />} /> */}
                {/* <Route path=':edit' element={<Warehouse />} /> */}
                {/* </Route> */}

                {/* Ruta del Warehouse con subrutas específicas */}
                <Route path="/warehouse" element={<Warehouse />}>
                    <Route path=":solProducts" element={<Warehouse />} />
                    <Route path=":settings" element={<Warehouse />} />
                </Route>

                {/* Ruta del Finance con subrutas específicas */}
                <Route path="/finance" element={<Finance />}>
                    <Route path=":settings" element={<Finance />} />
                    {/* <Route path=":settings/newCort" element={<Finance />} /> */}
                </Route>


                <Route path="/cashOut" element={<CashOut />} />








                <Route path="/reports" element={<Report />} />
                <Route path="/invoicing" element={<Invoicing />} />
                <Route path="/orderDeparture/:folio" element={<OrderDeparture />} />
                <Route path="/orderDeparture/:folio/:vista" element={<OrderDeparture />} />

                {/* Rutas Generales */}
                <Route path="/profile" element={<Profile />} />
                <Route path="/settings" element={<Global />} />

                {/* Redireccion por defecto */}
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>

        </>
    )
}
